<a class="root" [routerLink]="['/media/' + bac.url]">
  <div class="hoverlay"></div>
  <span class="text">{{ bac.translated$ | async }}</span>

  <rk-icon-button
    faIcon="fa-plus"
    [bordered]="true"
    (click)="clickMenu($event)"
  ></rk-icon-button>
</a>
